module.exports = __webpack_public_path__ + "./fonts/ManRope-Regular.ttf";